import { getStoredNow } from "./date";

//CONSTANTES PARTAGÉES POUR LES ÉVÈNEMENTS (création, modification, affichage)

//Page HelloAsso du club : les inscriptions aux évènements se font désormais ici
export const HELLOASSO_URL = "https://www.helloasso.com/associations/volley-ball-luzien-cibourien";

//Catégorie qui permet de saisir un nom de catégorie libre (champ "otherCategory")
export const OTHER_CATEGORY = "Autres événements";

export const EVENT_CATEGORIES = [
  "Animation estivale de Beach-Volley",
  "Beach-Volley VBLC",
  "Fête du thon",
  "Finale BLVB",
  "Forum des associations",
  "Information VBLC",
  "Sorties du club VBLC",
  "Tournoi Basko Beach",
  "Tournoi de la rentrée",
  "Tournoi des Fêtes",
  "Tournoi du carnaval",
  OTHER_CATEGORY,
];

//Suggestions proposées dans le champ "Type de tournoi" (la saisie reste libre)
export const TOURNAMENT_TYPE_SUGGESTIONS = [
  "Masculin 2x2",
  "Féminin 2x2",
  "Mixte 2x2",
  "Mixte 3x3",
  "Mixte 4x4",
  "Mixte 6x6",
];

//Texte affiché dans le détail de l'évènement quand une restauration est prévue
export const CATERING_TEXT = "Une offre de restauration est prévue sur place.";

//Nom de catégorie à afficher : pour "Autres événements", on affiche le nom saisi par le créateur
export const getCategoryLabel = (event) => event.category === OTHER_CATEGORY && event.otherCategory ? event.otherCategory : event.category;


//PÉRIODE D'AFFICHAGE D'UN ÉVÈNEMENT
//Un évènement est visible dans les "évènements à venir" entre son début et sa fin d'affichage.
//Évènements créés avant l'ajout de ces champs : on se rabat sur leur date de création et leur date de fin.
export const getDisplayStart = (event) => event.displayStartDate || event.createdAt || event.startDate;
export const getDisplayEnd = (event) => event.displayEndDate || event.endDate;

//Date servant au tri : début de l'évènement s'il est renseigné, sinon début d'affichage
export const getSortDate = (event) => new Date(event.startDate || getDisplayStart(event));

//"scheduled" = pas encore publié (invisible), "current" = dans les évènements à venir, "past" = éditions précédentes
//Comparaison à l'heure locale, selon la convention de stockage des dates (voir utils/date.js)
export const getEventStatus = (event, now = getStoredNow()) => {
  if (now < new Date(getDisplayStart(event))) return "scheduled";
  if (now < new Date(getDisplayEnd(event))) return "current";
  return "past";
};

//Évènements affichés dans "à venir", du plus proche au plus lointain
export const getCurrentEvents = (events, now = getStoredNow()) => events
  .filter((e) => getEventStatus(e, now) === "current")
  .sort((a, b) => getSortDate(a) - getSortDate(b));

//Éditions passées, de la plus récente à la plus ancienne
export const getPastEvents = (events, now = getStoredNow()) => events
  .filter((e) => getEventStatus(e, now) === "past")
  .sort((a, b) => getSortDate(b) - getSortDate(a));

//Type de publication selon la catégorie : tournoi (catégories commençant par "Tournoi"), communication ou évènement
export const INFORMATION_CATEGORY = "Information VBLC";
export const getCategoryKind = (categoryLabel = "") => {
  if (categoryLabel === INFORMATION_CATEGORY) return "Communication";
  if (/^tournoi/i.test(categoryLabel)) return "Tournoi";
  return "Évènement";
};
